module.exports = __webpack_public_path__ + "img/footer-link-1.dd41b0b3.svg";